export default "__VITE_ASSET__D$HBM$bQ__"